<template>
    <div>
	    <a class="btn-option" data-toggle="modal" data-target="#exampleModalCenter" @click="sharelocation">Compartir</a>

	    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	        <div class="modal-dialog modal-dialog-centered" role="document">
	            <div class="modal-content mod">
		            <div class="modal-header modHeader">
		                <h5 class="modal-title" id="exampleModalLongTitle">Compartir vínculo</h5>

		                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
		                	<span aria-hidden="true">&times;</span>
		                </button>
		            </div>

		            <div class="modal-body modBody">
		                <div class="row">
			                <div class="col-9">
			                   <input class="form-control form-control-sm mb-2" type="text" v-model="url" id="myInput" >     
			                </div>
							
			                <div class="col-3">
			                    <button class="btn btnCopy" @click="shareCopy()">Copiar</button>
			                </div>
		                </div>

		              	<span class="text-secondary pr">También puedes copiar el vínculo de la barra de direcciones del navegador.</span>
		            </div>
	            </div>
	        </div>
	    </div>
    </div>
</template>

<script>
	export default {
		data() {
		    return {
		       url: ''
	    	};
	  	},
		methods: {
			sharelocation() {
			this.url = window.location.protocol +'//'+ window.location.host + this.$router.history.current.fullPath;
				$('#exampleModalCenter').on('shown.bs.modal', function() {
					$('#myInput').select();
				})
			},
			shareCopy() {
				var copyText = document.getElementById("myInput");
				copyText.select();
				document.execCommand("Copy");

				const h = this.$createElement;
				this.$notify({
					title: 'Exito!',
					message: h('i', { style: 'color: teal' }, 'Enlace copiado!'),
					type: 'success'
				});
			}
		}	   
	}
</script>

<style>
	.modal-backdrop {
	    display: none;
	}
</style>

<style scoped>
	.btn-option {
		padding-left: 7px;
	}

	.sidenav a {
	    padding: 8px 8px 8px 50px !important;
	    text-decoration: none !important;
	    font-size: 15px !important;
	    color: #777 !important;
	    display: block;
	    transition: 0.3s;
	}
	.sidenav a:hover {
	    color: #2164f9 !important;
	}
	.pr {
	    font-size: 12px;
	}
	.mod {
	    box-shadow: 0 2px 15px rgba(0,0,0,0.5);
	    border: none !important;
	    border-radius: 6px !important;
	}
	.modHeader {
	    padding: 0.4rem 1rem !important;
	}
	.modBody {
	   border-radius: 6px;
	}
	.btnCopy {
		 width: 100%;
		 margin: 0px;
		 padding: 0px;
	    border-radius: 5px;
	    background: #2164f9 !important;
	    border-color:#2164f9 !important;
	    font-size: 13px;
	    color:#fff !important;
	    height: 32px;
	    -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
        box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
	    -webkit-transition: all .001s ease-in-out !important;
	    transition: all .001s ease-in-out !important;
	}
	.btnCopy:hover {
		 border-color: #0570f4!important;
	    color: #fff !important;
	    background-color: #0570f4!important;
	    -webkit-box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
        box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
	    position: relative;
	    cursor:pointer;
	}
</style>
